module.exports = __webpack_public_path__ + "static/media/whatsapp_white.e397a8f7.svg";